import { ArrowUpRight } from 'lucide-react'
import React, { useState } from 'react'
import { useModal } from '../contexts/ModalContext'
import FormularioRD from '../rdstation/formularioRD'
import AccordionServicos from './accordionServicos'
import BadgetOtimize from './badget-otimize'
import CardServicos from './cardServicos'
import Container from './container'

export default function FinopsBeneficios({ cards = [] }) {
  const { openModal } = useModal()
  const [openAccordionId, setOpenAccordionId] = useState(null)
  return (
    <div className="w-full bg-[#040116] bg-[url(/assets/beneficios-finops-mobile.png)] lg:bg-[url(/assets/cover-finops-beneficios.png)] pt-8 pb-36 md:py-24 relative overflow-hidden bg-cover bg-center">
      <Container className="relative z-10 space-y-0">
        <section>
          <div className="text-white font-inter-regular text-2xl md:text-[60px] flex justify-center mb-8 md:mb-24">
            Benefícios
          </div>

          <div className="hidden md:grid grid-cols-2 lg:grid-cols-3 gap-3">
            {cards.map((card, index) => (
              <div key={index}>
                <CardServicos
                  icon={card.icon}
                  iconHover={card.iconHover || card.icon}
                  title={card.title}
                  text={card.text}
                  glowColor={card.glowColor || '#A002CB'}
                  url={card.url}
                  className="h-full w-full"
                />
              </div>
            ))}
          </div>

          <div className="md:hidden space-y-3">
            {cards.map((card, index) => (
              <div key={index} className="space-y-4">
                <button
                  type="button"
                  onClick={() =>
                    setOpenAccordionId(
                      openAccordionId === card.id ? null : card.id,
                    )
                  }
                  className="w-full"
                >
                  <AccordionServicos
                    {...card}
                    className="bg-[rgb(36,29,73)] backdrop-blur-[92px]"
                    doesThereButton={false}
                  />
                </button>
                {openAccordionId === card.id && <BadgetOtimize />}
              </div>
            ))}
          </div>
        </section>

        <div className="hidden md:block mt-4 relative py-[2px] px-px rounded-[30px] bg-gradient-to-r from-[#4B3BDB] via-[#A002CB] to-[#FC0021] w-fit">
          <div className="flex items-center gap-8 bg-[#2B283D] px-6 py-3.5 rounded-[30px] text-white w-[350px]">
            <h3 className="w-fit font-inter-light">
              Otimize seu <br /> negócio!
            </h3>
            <button
              type="button"
              onClick={() => openModal(<FormularioRD />)}
              className="w-fit bg-white text-black text-sm font-inter-light flex items-center m-auto gap-2 py-2 px-10 rounded-full cursor-pointer hover:scale-105 transition-all duration-300"
            >
              Contratar <ArrowUpRight className="size-5" />
            </button>
          </div>
        </div>
      </Container>
    </div>
  )
}
